import { LANGUAGE, LOADING, SHOW_GLOBE, SET_LOCATION } from "../constants/ui";

export const getDefaultLanguage = () => {
  return localStorage.getItem("language") || "english";
};

export const setLoading = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload,
  });
};

export const setLanguage = (payload) => (dispatch) => {
  localStorage.setItem("language", payload);
  dispatch({
    type: LANGUAGE,
    payload,
  });
};

export const setGlobeView = (payload) => (dispatch) => {
  dispatch({
    type: SHOW_GLOBE,
    payload,
  });
};

export const setLocation = (payload) => (dispatch) => {
  dispatch({
    type: SET_LOCATION,
    payload,
  });
};
